import { t } from "i18next";
import { lngDetect } from "../../helpers/lngDetect";
import ContactForm from "../../pages/front/modules/Organization/ContactForm";
import Modal from "../elements/Modal";

const ContactFormModal = ({
  isOpen,
  onClose = () => {},
  data = {},
  organizationData = {},
}) => {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={onClose}
      title={`${t("Contact the event organiser")}: ${lngDetect(
        data?.organizationData?.name
      )}`}
      size="xl4"
      titleIcon="fa-regular fa-paper-plane"
      titleClass="!font-semibold !text-2xl !capitalize truncate max-w-[700px] w-full tracking-tight !text-deep-purple"
      headerClass="!text-black !rounded-t-2xl border-b border-surface-03 bg-primary/10 py-4 px-10"
      childrenClasses="!bg-white"
      bodyClasses={"!py-6"}
    >
      <ContactForm
        organizationId={organizationData?.data?._id}
        onClose={onClose}
      />
    </Modal>
  );
};

export default ContactFormModal;
